// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const nic: CountryValidator<"LK", ParsedPersonId> =
  createValidator("lk.nic", 115);

export default nic;
export const compact = nic.compact;
export const format = nic.format;
export const validate = nic.validate;
export const generate = (): string =>
  nic.generate?.() ??
  (() => {
    throw new Error(
      "Validator lk.nic cannot generate values",
    );
  })();
export const parse = nic.parse;
